import { gql } from '@apollo/client';

export const CREATE_INPUT = gql`
  mutation createInput($input: CreateInputInput!) {
    createInput(input: $input) {
      id
    }
  }
`;
